import { Link } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';
import { veracityColors, ModuleSwitcher, EnvBadge, UserMenu } from '@shared/ui';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: veracityColors.firstLight,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXL}`,
    backgroundColor: '#FFFFFF',
    borderBottom: `1px solid ${veracityColors.firstLight}`,
    boxShadow: tokens.shadow2,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    textDecoration: 'none',
    color: veracityColors.midnightCharcoal,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase500,
  },
  brandAccent: {
    color: veracityColors.veracityOrange,
  },
  logo: {
    width: '28px',
    height: '28px',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});

export function ShellLayout({ children }: { children: React.ReactNode }) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <Link to="/" className={styles.brand}>
          <img src="/daybreak-logo.svg" alt="" className={styles.logo} />
          <span className={styles.brandAccent}>Vera</span>
        </Link>
        <div className={styles.right}>
          <EnvBadge />
          <ModuleSwitcher />
          <UserMenu />
        </div>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
